import { api } from './api';

const getPagedList = async ({body}) => {
    const response = await api({
        url: `Invoices/getPagedList`,
        method: 'GET',
        params: {
            ...body,
            page: body.pageNumber,
        },
    });
    return response.data;
};


const currentAccountGetList = async ({body}) => {
    const response = await api({
        url: `CurrentAccounts/GetCurrentAccounts`,
        method: 'GET',
        params: body,
    });
    return response.data;
};

const currentAccountGetExcelFile = async (data) => {
    const response = await api({
        url: `CurrentAccounts/downloadCurrentAccountFile`,
        method: 'GET',
        responseType: 'arraybuffer',
        data,
    });
    return response.data;
};

const currentAccountGetPDFFile = async (data) => {
    const response = await api({
        url: `Report/currentAccountReport`,
        method: 'GET',
        responseType: 'arraybuffer',
        data,
    });
    return response.data;
};

const baBsGetList = async ({body}) => {
    const response = await api({
        url: `BaBsTrackings/getList`,
        method: 'GET',
        params: body,
    });
    return response.data;
};

const downloadInvoiceFile = async (data) => {
    const response = await api({
        url: `Invoices/downloadInvoiceFile`,
        method: 'POST',
        data,
        responseType: 'blob',
    });
    return response.data;
};

const downloadInvoiceArchiveFile = async (data) => {
    const response = await api({
        url: `invoicearchivefile`,
        method: 'POST',
        data,
        responseType: 'blob',
    });
    return response.data;
};

const invoicesServices = {
  getPagedList,
  baBsGetList,
  currentAccountGetList,
  currentAccountGetExcelFile,
  currentAccountGetPDFFile,
  downloadInvoiceFile,
  downloadInvoiceArchiveFile,
};

export default invoicesServices;
